export function getHeight(div: HTMLDivElement) {
    if (!div) {
        return 0;
    }
    const rect = div.getBoundingClientRect();
    return !!rect ? rect.height : 0;
}
